import React, { useEffect } from 'react';
import { Spin } from 'antd';
import { useAuth0 } from '@auth0/auth0-react';

/** Redirige al login de cliente vía Auth0 (sin selector cliente/empresa). */
const LoginClienteAuth0 = () => {
  const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      loginWithRedirect();
    }
  }, [isLoading, isAuthenticated, loginWithRedirect]);

  return (
    <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Spin size="large" tip="Redirigiendo al login..." />
    </div>
  );
};

export default LoginClienteAuth0;
